import { isPhoneInLandscape } from '../../../../styles'
import colors from '../../../../theming/docusign-themes/olive/colors'

export default () =>
  ({
    default: {
      wrap: {
        borderTop: `1px solid ${colors.gray3}`,
        padding: '12px 24px',

        [isPhoneInLandscape]: {
          padding: '10px',
        },
      },
    },

    children: {
      wrap: {
        [isPhoneInLandscape]: {
          padding: '10px',
        },

        '& > button': {
          '&:first-of-type': {
            marginInlineEnd: '10px',
          },
        },
      },
    },
  }) as const
